var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6477 0.238061C11.2742 -0.0793536 10.7258 -0.0793536 10.3524 0.238061L0.352372 8.73806C-0.0684358 9.09575 -0.119606 9.72684 0.238081 10.1476C0.595767 10.5685 1.22686 10.6196 1.64767 10.2619L2.5 9.53746V16C2.5 18.2091 4.29086 20 6.5 20H15.5C17.7091 20 19.5 18.2091 19.5 16V9.53742L20.3524 10.2619C20.7732 10.6196 21.4043 10.5685 21.762 10.1476C22.1196 9.72684 22.0685 9.09575 21.6477 8.73806L11.6477 0.238061ZM17.5 7.83742L11 2.31244L4.5 7.83746V16C4.5 17.1046 5.39543 18 6.5 18H15.5C16.6046 18 17.5 17.1046 17.5 16V7.83742Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.f2e0d3d2b31d55235d4ba57d39102ded.svg";
export { ForwardRef as ReactComponent };